<template>
  <div>
    <div v-show="!showUpdate" class="app-content content ">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
                name="Roles"
                bc1="App"
                bc2="Roles"
                bc3="List"
            ></Breadcrumb>
          </div>

        </div>
        <div class="content-body">
          <div class="card">
            <div class="m-2">
              <div class="row">
                <div class="col-md-12 col-12">
                  <div class="d-flex align-items-center justify-content-end">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="$router.push({ name: 'roles-add' })"
                    >
                      <AddButtonText name="Role" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <CommonTableStore
                :url="url"
                :tableHeaderValues="tableHeaderValues"
                :actions="actions"
                :deleteActions="deleteActions"
                :mutedData="mutedData"
                :storageKey="storageKey"
                :filteredData="filteredData"
                :externalTotalRecord="externalTotalRecord"

            />
          </div>
        </div>
      </div>
    </div>
    <UpdateRoles @back="showUpdate = false" v-if="showUpdate" />
  </div>

</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import UpdateRoles from "@/pages/dashboard/roles/updateRoles.vue";
import UpdateSettings from "@/pages/dashboard/settings/UpdateSettings.vue";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  components: {AddButtonText, UpdateSettings, CommandIcon,UpdateRoles },

  mounted() {
    localStorage.setItem("url", "v1/get-role-user");
    this.checkDataInStore('v1/get-role-user')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      url: "v1/get-role-user",
      storageKey: "roles",
      showUpdate:false,
      filteredData:{type: 1 },
      isDefault: false,
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name"
        },
        {
          title: "Display Name",
          valueKey: "display_name"
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }

            // if (row.is_default == 1) {
            //   this.isDefault = true;
            //   html += '<span class="badge badge-secondary ml-1">Default</span>';
            // }

            return html;
          }
        }
      ],
      actions: [
        {
          title: "Update",
          class: "btn-primary",
          cta: (row, index) => {
            let data = {
              ...row,
              index: index,
              row: row,
              key: "roleUpdate",
              storageKey: this.storageKey,
              idx: index,
            }
            this.$store.dispatch("set", data);
            this.showUpdate = true

          }
        },
        {
          title: "Permissions",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "rolesPermissions"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "roles-permissions",params: {roleId :row.id}})
          }
        },
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "rolesDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    deleteRecord(data) {
      this.makeRequest("post", "v1/update-role-status", {
        status: data.row.status == true ? 1 : 0,
        id: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey("roles");
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                  typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                  typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = "roles";
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  }
};
</script>
